export default __webpack_public_path__ + "static/media/Prophecy_En.2e3ee52c.webp";